require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-aws-without-breaking-the-bank.json") })
        }
      }, "path---blog-aws-without-breaking-the-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-aws-without-breaking-the-bank!./.cache/json/blog-aws-without-breaking-the-bank.json
// module id = 721
// module chunks = 231608221292675